module.exports = "<p-growl [value]=\"msgs\" life=\"3000\"></p-growl> \n<router-outlet></router-outlet>\n\n"